export default "__VITE_ASSET__CtILYJeo__"